import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { memo, useCallback, useMemo, useState } from "react";
import MainApi from "./../../../../../services/mainApi.service";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { IMarComAutomationTime } from "../../../../../models/mar-com-automation-time";
import TimeRules from "./TimeRulesForm/TimeRules";

const TICKET_AUTOMATION_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationTime/";
const ticketAutomationService = new MainApi<IMarComAutomationTime>(
  TICKET_AUTOMATION_ROUTE
);

const translationPath = "page.4uMarCom.automationRules.marcom_timerule.";

export const TimeRulesPage = memo(() => {
  const [timeRuleForm, setTimeRuleForm] = useState(false);

  const { id } = useParams();

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const columns: GridColDef<IMarComAutomationTime>[] = [
    {
      field: "ticketAutomationTimeClassification",
      headerName:
        t(translationPath + "time_classification") || "Time Classification",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={
              params.row.ticketAutomationTimeClassification.timeClassification
                .name
            }
            tooltip={
              params.row.ticketAutomationTimeClassification.timeClassification
                .name
            }
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "typeofTypeFraction",
      headerName: t(translationPath + "type") || "type",
      maxWidth: 200,
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "value",
      headerName: t(translationPath + "value") || "Value",
    },
  ];

  const handleAdd = () => {
    setTimeRuleForm(true);
  };

  const handleRowClick = (params: GridRowParams<IMarComAutomationTime>) => {
    if (!params.row) return;
    setTimeRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTimeRuleForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      TicketAutomationRuleId: id,
    };
  }, [id]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {timeRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <TimeRules
            id={selectedId}
            marComAutomationRuleId={id}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!timeRuleForm && (
        <Box height={600}>
          <Table<IMarComAutomationTime>
            showDefaultMacroFilters={false}
            service={ticketAutomationService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            serviceProps={props}
            searchInputPlaceHolder={
              t(translationPath + "search") || "Searh for a time rule"
            }
            addButtonLabel={
              t(translationPath + "add_time_rule") || "Add Time Rule"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
